export class EnrollCompany {
    firstName: string;
    lastName: string;
    name: string;
    uniqueCode : string;
    identificationCode : string;
    address : string;
    city : string;
    email : string;
    phone : string;
    installationType: number;
    hardwarePackage: boolean;
    ownerUid: string;
}

export enum InstallationTypeEnum {
    Self = 0,
    Remote = 1,
    Office = 2
  }
